export const inputFieldClasses = 'w-full';

export const inputFieldStyleClasses =
    'w-full bg-white border border-border px-3 py-1.5 rounded-md h-10';

export const textareaFieldStyleClasses =
    'w-full bg-white border border-border px-3 py-1.5 rounded-md h-40';

export const labelStyleClasses = 'mb-2 text-content';

export const errorMessageClasses = 'mt-1 ml-1 text-danger';
